module.exports = __webpack_public_path__ + "img/familia.456eb9f8.jpg";